<template>
  <b-card title="Importazioni in corso">
    <b-alert :show="processes.length == 0" variant="info">Nessuna importazione in corso</b-alert>
    <b-progress class="mb-5" height="40px" variant="primary" :max="100"  show-progress animated v-for="(p, i) in processes" :key="i">
      <b-progress-bar :value="p.backgroundImport.progress">
        {{ p.backgroundImport.name }} {{ p.backgroundImport.progress.toFixed(0) }}%
        </b-progress-bar>
    </b-progress>
  </b-card>
</template>

<script>
export default {
  name: "Status",
  data() {
    return {
      processes: [],
      intl: 0
    }
  },
  created() {
    /*this.intl = setInterval(() => {
      this.$store.dispatch('datasheets/status').then(data => {
        this.processes = data
      })
    }, 2000)*/
  },
  beforeDestroy() {
    console.log("before destroy")
    clearInterval(this.intl)
  }
}
</script>

<style>
.progress-bar {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Import/Status.vue